export { default as Auth } from 'utils/Auth';
export { default as getBearerHeaders } from 'utils/getBearerHeaders';
export { default as FormUtils } from 'utils/FormUtils';
export { default as validators } from 'utils/validation';
export { default as redirectToLogin } from 'utils/redirectToLogin';
export { default as humanizedDate } from 'utils/humanizedDate';
export { default as createErrorKey } from 'utils/createErrorKey';
export { default as getPaymentCardIcon } from 'utils/paymentCardIcons';
export {
  formatPhoneNumberForDisplay,
  formatPhoneNumberForAPI,
} from 'utils/format';
export { getCurrencySymbol, getCurrencyLocale } from 'utils/currencyUtils';

// TODO: missing function
export const logError = () => {
  /* console.error('Error'); */
};
